import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICountry } from "../../models/Country";

interface ICountriesSlice {
  allCountries: ICountry[];
}

const initialState: ICountriesSlice = {
  allCountries: [],
};

const countriesSlice = createSlice({
  name: "countriesSlice",
  initialState,
  reducers: {
    setAllCountries: (state, action: PayloadAction<ICountry[]>) => {
      state.allCountries = action.payload;
    },
  },
});

export const { setAllCountries } = countriesSlice.actions;

export default countriesSlice.reducer;
